<div class="d-inline-flex">
  <ncp-button
    #addContactButton
    [options]="btnCOptions()"
  >
    @if(cLoading) {
      <div class="loading spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else {
      <i
        class="bi bi-person-plus healthIcon"
      >
      </i>
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="contacts_form"
      name="contacts_form"
      [formGroup]="form"
      #cFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-input #name [(options)]="nameInputOptions" />
      <ncp-input #surname [(options)]="surnameInputOptions" />
      <ncp-input #address [(options)]="addressInputOptions" />
      <ncp-dropdown #countryDesc [(options)]="countryDescDDOptions" />
      <ncp-input #phone [(options)]="phoneInputOptions" />
      <ncp-input #email [(options)]="emailInputOptions" />
    </form>
  </ncp-modal>
</div>
